import { render, staticRenderFns } from "./CreateCampaignsModal.vue?vue&type=template&id=fff3c060&scoped=true&"
import script from "./CreateCampaignsModal.vue?vue&type=script&lang=js&"
export * from "./CreateCampaignsModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCampaignsModal.vue?vue&type=style&index=0&id=fff3c060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff3c060",
  null
  
)

export default component.exports